import styled from 'styled-components'
import { colors } from 'styles/colors'
import { mobile } from 'styles/responsive'

export const Subtitle = styled.h2`
    position: relative;

    font-size: 24px;
    font-weight: 700;
    line-height: 30px;

    color: ${colors.darkGreen};

    &:before {
        content: '';
        position: absolute;
        height: 5px;
        width: 10%;
        background-color: ${colors.darkGreen};
        border-radius: 4px;
        bottom: -15px;
    }

    ${mobile(`
        font-size: 22px;
    `)}
`

export const Content = styled.div`
    max-width: 1140px;
    margin: 0 15px;
    display: flex;
    justify-content: center;
    text-align: left;
    overflow: hidden;

    ${mobile(`
        flex-direction: column-reverse;
        align-items: center;

        img {
            width: 100%;
        }
    `)}
`

export const Info = styled.div`
    max-width: 500px;
    display: flex;
    flex-direction: column;
    flex-grow: 0;

    > * + * {
        margin-top: 25px;
    }

    ${mobile(`
        min-width: 0;
        padding: 0;
        column-gap: 20px;

        .more {
            display: none;
        }
    `)}
`

export const Banner = styled.div`
    flex-shrink: 1;
    display: flex;

    img {
        width: 100%;
    }
`

export const List = styled.div`
    display: flex;
    flex-wrap: wrap;
    row-gap: 10px;

    > * + * {
        margin-top: 10px;
    }

    ${mobile(`
        row-gap: 10px;
        
        > * + * {
            margin-top: 0;
        }
    `)}
`

export const BenefitContainer = styled.div`
    flex: 50%;
    display: flex;
    align-items: center;
    column-gap: 10px;

    &.placeholder {
        visibility: hidden;
    }

    ${mobile(`
        flex-direction: column;
        row-gap: 10px;
        text-align: center;
        padding: 10px 0;

        img {
            width: 80px;
            height: 80px;
        }

        &.placeholder {
            visibility: visible;

            img {
                visibility: hidden;
            }
        }
    `)}
`

export const BenefitName = styled.span`
    font-weight: 700;
    font-size: 20px;
    line-height: 25px;
    color: ${colors.darkGreen};

    ${mobile(`
        color: #333;
        font-size: 17px;
    `)}
`
